import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  MenuItem,
  Menu,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { ListItemButton } from "@mui/material";
import { ArrowDropDownOutlined, LogoutOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Container from "@mui/material/Container";
import { logout } from "../actions/auth.js";
import Footer from "./Footer.jsx";
import Navbar from "./Navbar.jsx";
import quorumLogo from "../images/quorum-logo.png";
import GlobalSearch from "../pages/global-search/global-search.jsx";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    color: "#000133",
  },
  container: {
    width: "100%",
  },
  sidebar: {
    background: "#002554",
    display: "flex",
    border: "none",
    justifyContent: "flex-start",
    width: "100%",
  },
  main: {
    background: "#f7f5f5",
    overflowY: "scroll",
    height: "100vh",
    paddingBottom: 2,
    
  },
};

export default function Layout({ children }) {
  const dispatch = useDispatch();
  const { data: user } = useSelector((state) => state.user);

  const { pathname } = useLocation();
  //-----Dropdown Logout--------
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={styles.root}>
      <AppBar position="sticky" className="header-bg">
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <div>
              <Link to="/transaction-list">
                <img src={quorumLogo} className="logo-inner" />
              </Link>
            </div>
            <div style={{ width: "450px", marginBottom: "10px" }}>
              <GlobalSearch />
            </div>

            <Box
              sx={{ flexGrow: 0 }}
              display="flex"
              alignItems="center"
              columnGap={2}
              className="userBox"
            >
              <IconButton
                edge="start"
                title="Log Out"
                color="inherit"
                aria-label="menu"
                onClick={handleClick}
                size="small"
                sx={{ ml: 2, borderRadius: 0, marginLeft: 0 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <PersonIcon className="userIconColor" />
                <Typography style={{ textTransform: "capitalize" }}>
                  {user.name && user.name.length > 0
                    ? user.name.charAt(0).toUpperCase() + user.name.slice(1)
                    : ""}
                </Typography>
                <ArrowDropDownOutlined />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    dispatch(logout());
                  }}
                  className="signOutBtn"
                >
                  <ListItemIcon>
                    <LogoutOutlined fontSize="small" />
                  </ListItemIcon>
                  SignOut
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <div style={styles.container}>
        <Box sx={styles.sidebar} className="tabs-bg p-0">
          <Container maxWidth="xl" className="navbar-plr0">
            <Navbar />
          </Container>
        </Box>
        <Container maxWidth="xl">
          <Box component="main" className="main-container" p={4}>
            {children}
          </Box>
          <Footer></Footer>
        </Container>
      </div>
    </div>
  );
}

function SidebarListItem({
  icon,
  text = "Link To",
  href = "#",
  active = false,
}) {
  const { pathname } = useLocation();

  return (
    <ListItem
      sx={{
        padding: 0,
        background: pathname === href ? "#f7f5f5" : "inherit",
        width: "fit-content",
      }}
    >
      <Link
        to={href}
        style={{ width: "100%", textDecoration: "none", color: "inherit" }}
      >
        <ListItemButton
          className="menu-button"
          sx={{
            pr: 1,
            pl: 1,
            borderBottom: active ? "3px solid #a7cf36" : "inherit",
          }}
        >
          <ListItemText primary={text} />
        </ListItemButton>
      </Link>
    </ListItem>
  );
}
